import $ from 'jquery';

$(document).ready(function () {
    $('.bonus.button')
    .popup({
        popup: $('.bonus.popup'),
        on: 'click'
    })
    ;
});
